<template>
  <div class="background main-background" :style="{backgroundImage: `url(${backgroundPath})`}">
    <div class="background overlay-background"
      v-if="backgroundOverlayPath"
      :style="{backgroundImage: `url(${backgroundOverlayPath})`}"
      data-aos="fade"
      data-aos-duration="1200"
      data-aos-anchor="#trigger"
      data-aos-anchor-placement="top-top"
    >
      <div id="trigger"></div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {}
  },
  props: ['backgroundPath', 'backgroundOverlayPath']
}
</script>

<style scoped>
  @import url('../../../static/css/components-style/header.css');
</style>



// WEBPACK FOOTER //
// src/components/COMMON/HeaderBackground.vue